<template>
  <div :class="mainContentClass" id="makeRoute">
    <el-button style="margin-top: 12px" class="backButton" @click="back"
      >返回</el-button
    >
    <div>
      <div class="appIntro">
        <div class="line"></div> 
        <div class="lineText">应用介绍</div>
      </div>
      <p class="makeRouteText">
        “生成道路”用于将道路数据从施工坐标系转换成平台相对坐标系，同时将设计参数转换成逐桩坐标，从而生成本地平台可以使用的道路数据，支持无人化施工等应用，该应用在本地平台也有布置（道路管理
        > 道路详情 > 生成道路）。
        完成道路数据生成需要3步：导入设计数据、坐标计算、坐标转换。
      </p>
    </div>
    <el-steps class="stepLine" :active="active">
      <el-step title="导入设计数据"></el-step>
      <el-step title="坐标计算"></el-step>
      <el-step title="坐标转换"></el-step>
    </el-steps>
    <p class="makeRouteTextP">
      *进行道路数据生成，需要准备 <span class="underline" @click="downloadTemplate(0)">“道路设计参数”</span> 和 <span class="underline" @click="downloadTemplate(1)">“数据转换规则” </span>
    </p>
    <p class="makeRouteTextP">*准备好了？那就马上开始吧</p>
    <el-button
      class="beginButton"
      style=""
      @click="next"
      >马上开始</el-button
    >
    <el-divider></el-divider>
    <div>
      <div class="makeRouteTitle">
          <div class="line"></div>
        <div class="lineText">历史介绍</div>
      </div>
      <div class="historyFileBox">
        <div
          class="history_file"
          @click="downloadRoadData(val.id, val.roadName)"
          v-for="(val, i) in historyFileList"
          :key="i"
        >
          <i class="fileIcon"></i>
          <div class="fileText">
            {{ val.roadName }}   <div>{{ val.createTime.substring(0, 16) }}</div>
          </div>
        </div>
      </div>
      <el-pageCover
        class="pageBlock"
        :pageMsg="pageMsg"
        @sizeChange="pageSizeChange"
        @currentChange="currentPageChange"
      ></el-pageCover>
    </div>
  </div>
</template>
<script>
import ElPageCover from "../../components/overall/ElPageCover";
import { roadDataList, downloadRoadFile,downloadRoadExampleFile } from "../../utils/api";
export default {
  name: "app",
  data() {
    return {
      historyFileList: [],
      arrowList: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "应用中心",
          path: "/transfer/application",
        },
        {
          name: "生成道路",
          path: "",
        },
      ],
      active: 3,
      pageMsg: {
        pageSize: 5,
        pageNo: 1,
        totalRecords: 25,
      },

    };
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.initTable();
  },
  computed : {
    mainContentClass : function(){
      if(this.pageMsg.pageSize==10){
        return "mainContent mainContentPlus";
      }else{
        return "mainContent mainContentMini";
      }
    }
  },
  methods: {
    async downloadTemplate(type){
      var param = {
        type: type,
      };
      let roadName = "";
      if(type==0){
        roadName = "道路设计参数模板";
      }else if(type==1){
        roadName = "转换规则";
      }
      const InstructionManualvv = await downloadRoadExampleFile(param);
      let blob = new Blob([InstructionManualvv.data], {
        type: "application/vnd.ms-excel;charset=UTF-8",
      });
      let fileName = roadName + ".xls";
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href); //释放内存
      }
    },
    next() {
      this.$router.push({ name: "ImportDesignData" });
      //   if (this.active++ > 2) this.active = 0;
    },
    back() {
      this.$router.push({ name: "Application" });
    },
    pageSizeChange(size) {
      this.pageMsg.pageSize = size;
      this.initTable();
    },
    currentPageChange(index) {
      this.pageMsg.pageNo = index;
      this.initTable();
    },
    initTable() {
      var that = this;
      var param = {
        pageNo: this.pageMsg.pageNo,
        pageSize: this.pageMsg.pageSize
      };
      roadDataList(param).then((res) => {
        let info = res.data.content.info;
        that.pageMsg.totalRecords = info.totalRecords;
        let list = info.list;
        that.historyFileList = list;
      });
    },
    async downloadRoadData(id, roadName) {
      var param = {
        roadId: id
      };

      const InstructionManualvv = await downloadRoadFile(param);
      let blob = new Blob([InstructionManualvv.data], {
        type: "application/vnd.ms-excel;charset=UTF-8",
      });
      let fileName = roadName + ".xls";
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href); //释放内存
      }
    },
  },
  components: {
    ElPageCover,
  },
};
</script>
<style lang="scss">
#makeRoute {
  .el-step__icon {
    width: 56px;
    height: 56px;
    color:#000000;
  }
  .el-step__head.is-finish {
    color: #cccccc;
    border-color: #cccccc;
  }
  .el-step.is-horizontal .el-step__line {
    height: 0.104vw;
    top: 27px;
    left: 205px;
    right: 0px;
    width: 220px;
  }

   .el-step:nth-child(2) .el-step__title{
    left: 90px;
    width: 220px;
}

  .el-step__main .el-step__title {
    width: auto;
    position: relative;
    bottom: 62px;
    font-size: 20px!important;
    left: 70px;
    color:#000000;
    font-weight: bold;
  }
  .el-step__icon-inner{
    font-size:20px;
  }
  .el-divider--horizontal{
      width:60%;
      margin-left:20%;
  }
  .pageBlock .el-pager .active{
      background-color: #E60000 !important;
  }
}
</style>
<style lang="scss" scoped="">
.backButton {
  position: absolute;
  right: 20px;
  top: 60px;
}
.beginButton{
  margin-top: 12px; 
  margin-left: 20%;
  width:134px;
  height:48px !important;
  background:#E60000;
  border-radius: 2px;
  color:white;
}
.stepLine {
  width: 50%;
  //   display: block;
  margin-left: 25%;
}
.makeRouteText {
  width: 60%;
  margin-left: 20%;
  margin-top: 100px;
  font-size: 16px;
  line-height: 28px;
}
.makeRouteTitle {
  margin-left: 20%;
  font-weight: bold;
}
.appIntro {
  position: relative;
  bottom: 80px;
  left: 20%;
}
.mainContent {
  height: 1000px;
  background: #fff;
  padding-top: 50px;
}
.mainContentPlus{
  height:1000px;
}
.mainContentMini{
  height:800px;
}
.historyFileBox {
    padding-left: 20%;
    padding-top: 2.604vw;
    width: 70%;
}
.pageBlock {
    float: right;
    position: relative;
    top: 120px;
    right: 52%;
}
.history_file {
  width: 150px;
  margin-bottom: 30px;
  display: inline-block;
  margin-left: 20px;
  cursor: pointer;
  height: 150px;
  float:left;
}
.line {
  height: 16px;
  width: 4px;
  background-color: #fa0c28;
  float: left;
}
.lineText {
  float: left;
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  color: #222222;
  font-weight: bold;
  margin-left: 10px;
}
.makeRouteTextP{
  width: 60%;
  margin-left: 20%;
  font-size: 16px;
  line-height: 28px;
}
.fileIcon{
  display: block; 
  font-size: 50px;
  background-image: url(../../images/icon/doc.png);
  width: 36px;
  height: 48px;
}
.fileText{
  margin-top:10px;
  font-size:12px;
}

.underline{
  text-decoration:underline;
  cursor:pointer;
}

</style>

